@if (phone(); as phone) {
  {{ phone | onyxPhone }}
} @else {
  -
}
